<template>
<!-- <v-layout column style="height: 33vh">
  <v-flex md style="overflow: auto"> -->
    <v-data-table dense fixed-header height="310" no-data-text="اطلاعاتی موجود نیست" :headers="headers" :items="data" disable-pagination hide-default-footer item-key="_id">
      <template v-slot:[`item.price`]="{ item }">
        <template v-if="item.price">
          <span>{{ item.price.toLocaleString() }}</span>
        </template>
      </template>
    </v-data-table>
  <!-- </v-flex>
</v-layout> -->
</template>
<!-- show-select v-model="selected" -->
<script>
export default {
  name: "table-list",
  props: ['loading', 'headers', 'data'],
  data() {
    return {}
  },
};
</script>

<style lang="scss">
table,
td {
    border: 2px solid lightgray;
    border-collapse: separate;
    font-size: 20px !important;
    // color: blue;
}
th {
    border: 3px solid lightgray;
    border-collapse: inherit;
    font-size: 20px !important;
    background-color: #546E7A !important;
    color: whitesmoke !important;
    // text-align: center;
}
table tr:nth-child(odd) {
    background-color: #fff;
}
table tr:nth-child(even) {
    background-color: #eee;
}
</style>
